import { motion } from "framer-motion";

export type SpinnerProps = {
  message?: string;
  size?: string;
  className?: string;
}

export const Spinner = (props: SpinnerProps) => {
  return (
    <>
      <motion.div
        className={`aspect-square ease-linear rounded-full border-8 border-t-blue-500 border-b-gray-200 border-l-gray-200 border-r-gray-200 ${props.className || ""}`}
        style={{ width: props.size || '100px' }}
        animate={{ rotate: 360 }}
        transition={{ ease: "linear", duration: 1, repeat: Infinity }}
      />
      {props.message &&
        <p className="text-gray-700 dark:text-gray-300 text-xl mt-4">{props.message}</p>
      }
    </>
  )
}